import { createStore } from '@/zustand/middlewares'

import { UsePriceRangeStore } from './ts'

const usePriceRangeStore = createStore<UsePriceRangeStore>(
  'PRICE_RANGE',
  (set) => ({
    priceRange: [0, 0],
    fieldset: [0, 0],

    setPriceRange: (priceRange: number[]) => set(() => ({ priceRange })),

    setFieldset: (fieldset: number[]) => set(() => ({ fieldset })),
  })
)

export const { setPriceRange, setFieldset } = usePriceRangeStore.getState()

export default usePriceRangeStore
